export const LOGOUT_ACTION = 'auth/logout' as const
export const RESET_ACTION = 'RESET' as const
